import { supabase } from '@/lib/supabase'

export type ThermometerRow = {
  opportunity_id: string
  symbol: string
  percent: number
  updated_at: string
  breakdown?: any
}

export async function fetchThermometerMap(opportunityIds: string[]): Promise<Map<string, ThermometerRow>> {
  const map = new Map<string, ThermometerRow>()
  if (!opportunityIds || opportunityIds.length === 0) return map
  // Converter para números para evitar mismatch de tipo (tabela usa bigint)
  const idsNum = Array.from(new Set(opportunityIds))
    .map((s) => {
      const n = Number(String(s).trim())
      return Number.isFinite(n) ? n : null
    })
    .filter((n): n is number => n !== null)
    .slice(0, 1000)
  const { data, error } = await supabase
    .from('opportunity_thermometer')
    .select('opportunity_id,symbol,percent,updated_at')
    .in('opportunity_id', idsNum)
  if (error) return map
  for (const r of Array.isArray(data) ? data : []) {
    const row = {
      opportunity_id: String((r as any).opportunity_id),
      symbol: String((r as any).symbol).toUpperCase(),
      percent: Math.round(Math.max(0, Math.min(100, Number((r as any).percent || 0)))) ,
      updated_at: String((r as any).updated_at || new Date().toISOString()),
    }
    map.set(row.opportunity_id, row)
  }
  return map
}

export async function fetchThermometerById(opportunityId: number): Promise<ThermometerRow | null> {
  const { data, error } = await supabase
    .from('opportunity_thermometer')
    .select('opportunity_id,symbol,percent,updated_at,breakdown')
    .eq('opportunity_id', opportunityId)
    .maybeSingle()
  if (error) return null
  if (!data) return null
  return {
    opportunity_id: String((data as any).opportunity_id),
    symbol: String((data as any).symbol || '').toUpperCase(),
    percent: Math.round(Math.max(0, Math.min(100, Number((data as any).percent || 0)))),
    updated_at: String((data as any).updated_at || new Date().toISOString()),
    breakdown: (data as any).breakdown || null,
  }
}
